/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerStreamResponseQueryResponse, MultiDocumentAgentControllerStreamResponsePathParams, MultiDocumentAgentControllerStreamResponse401, MultiDocumentAgentControllerStreamResponse403, MultiDocumentAgentControllerStreamResponse404, MultiDocumentAgentControllerStreamResponse503 } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerStreamResponse";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { multiDocumentAgentControllerStreamResponse } from "../../clients/multi-document-agentService/multiDocumentAgentControllerStreamResponse";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const multiDocumentAgentControllerStreamResponseQueryKey = (requestId: MultiDocumentAgentControllerStreamResponsePathParams["requestId"]) => [{
  url: '/api/v1/multi-document-agent/stream/:requestId',
  params: {
    requestId: requestId
  }
}] as const;
export type MultiDocumentAgentControllerStreamResponseQueryKey = ReturnType<typeof multiDocumentAgentControllerStreamResponseQueryKey>;
export function multiDocumentAgentControllerStreamResponseQueryOptions(requestId: MultiDocumentAgentControllerStreamResponsePathParams["requestId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = multiDocumentAgentControllerStreamResponseQueryKey(requestId);
  return queryOptions<MultiDocumentAgentControllerStreamResponseQueryResponse, ResponseErrorConfig<MultiDocumentAgentControllerStreamResponse401 | MultiDocumentAgentControllerStreamResponse403 | MultiDocumentAgentControllerStreamResponse404 | MultiDocumentAgentControllerStreamResponse503>, MultiDocumentAgentControllerStreamResponseQueryResponse, typeof queryKey>({
    enabled: !!requestId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return multiDocumentAgentControllerStreamResponse(requestId, config);
    }
  });
}

/**
 * @description Streams real-time agent events from Redis Streams. Supports multi-instance horizontal scaling.
 * @summary Stream agent responses via Server-Sent Events
 * {@link /api/v1/multi-document-agent/stream/:requestId}
 */
export function useMultiDocumentAgentControllerStreamResponse<TData = MultiDocumentAgentControllerStreamResponseQueryResponse, TQueryData = MultiDocumentAgentControllerStreamResponseQueryResponse, TQueryKey extends QueryKey = MultiDocumentAgentControllerStreamResponseQueryKey>(requestId: MultiDocumentAgentControllerStreamResponsePathParams["requestId"], options: {
  query?: Partial<QueryObserverOptions<MultiDocumentAgentControllerStreamResponseQueryResponse, ResponseErrorConfig<MultiDocumentAgentControllerStreamResponse401 | MultiDocumentAgentControllerStreamResponse403 | MultiDocumentAgentControllerStreamResponse404 | MultiDocumentAgentControllerStreamResponse503>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? multiDocumentAgentControllerStreamResponseQueryKey(requestId);
  const query = useQuery({
    ...multiDocumentAgentControllerStreamResponseQueryOptions(requestId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<MultiDocumentAgentControllerStreamResponse401 | MultiDocumentAgentControllerStreamResponse403 | MultiDocumentAgentControllerStreamResponse404 | MultiDocumentAgentControllerStreamResponse503>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}